<div class="footer-container">
    <div class="buttons-container">
        <app-button
            class="button"
            [class.select]="currentMode === 'text'"
            [text]="'mimic.canvas.mode.text'"
            [variant]="BUTTON_TEXT"
            [iconButton]="true"
            iconSize="20px"
            icon="text"
            customFontColor="var(--editor-toolbar-font-color)"
            customFontFamily="NotoSans"
            customFontWeight="400"
            (onClick)="setMode('text')"></app-button>
        <app-editor-dropdown
            [items]="DRAW_ITEM_LIST"
            [translatePrefix]="'mimic.canvas.mode.draw'"
            [title]="'mimic.canvas.mode.draw.title'"
            [icon]="'draw-pan'"
            (onSelectedItem)="dropDownChange($event)"></app-editor-dropdown>
        <app-editor-dropdown
            [items]="CONNECTOR_ITEM_LIST"
            [translatePrefix]="'mimic.canvas.mode.connectors'"
            [title]="'mimic.canvas.mode.connectors.title'"
            [icon]="'connect'"
            (onSelectedItem)="dropDownChange($event)"></app-editor-dropdown>
        <app-editor-dropdown
            [items]="CONTROL_ITEM_LIST"
            [translatePrefix]="'mimic.canvas.mode.controls'"
            [title]="'mimic.canvas.mode.controls.title'"
            [icon]="'control'"
            (onSelectedItem)="dropDownChange($event)"></app-editor-dropdown>
        <app-editor-dropdown
            [items]="SHAPE_ITEM_LIST"
            [translatePrefix]="'mimic.canvas.mode.shapes'"
            [title]="'mimic.canvas.mode.shapes.title'"
            [icon]="'shape'"
            (onSelectedItem)="dropDownChange($event)"></app-editor-dropdown>
    </div>
    <div class="icons-container">
        <ng-container *ngFor="let functionItem of FUNCTION_LIST; index as i">
            <ng-container *ngIf="shouldShowIcon(functionItem)">
                <div
                    class="function-button"
                    [class.select]="currentMode === functionItem.name"
                    (click)="setMode(functionItem.name)">
                    <mat-icon
                        class="icon"
                        [matTooltip]="functionItem.tooltip | translate"
                        [svgIcon]="functionItem.svgIcon"></mat-icon>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>

<ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-component"></app-loading-spinner></ng-container>
